import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Respuesta } from '../../_models/shared/_index';
import { environment } from '../../../environments/environment';
import { ErrorService } from '../error.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class MultimediaService {
	private guardarMultimediaUrl =
		environment.rest + '/ComparadorRest/GuardarMultimedia';
	private getMultimediaByNodoUrl =
		environment.rest + '/ComparadorRest/GetMultimediaByNodo';
	private deleteMultimediaUrl =
		environment.rest + '/ComparadorRest/DeleteMultimedia';
	private countMultimediaByNodoUrl =
		environment.rest + '/ComparadorRest/CountMultimediaByNodo';
	private downloadMultimediaUrl =
		environment.rest + '/ComparadorRest/DownloadMultimedia';
	private renameMultimediaUrl =
		environment.rest + '/ComparadorRest/RenameMultimedia';

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(private http: HttpClient, private errorService: ErrorService) {}

	guardarMultimedia(
		idNodo: number,
		profundidad: number,
		nombre: string,
		ruta: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.guardarMultimediaUrl,
				{ idNodo, profundidad, nombre, ruta },
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(
						`post guardarMultimedia ruta=${ruta}`
					)
				)
			);
	}

	getMultimediaByNodo(
		idNodo: number,
		profundidad: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getMultimediaByNodoUrl,
				{ idNodo, profundidad },
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`post getMultimediaByNodo`)
				)
			);
	}

	deleteMultimedia(idMultimedia: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.deleteMultimediaUrl, { idMultimedia }, options)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`post deleteMultimedia`)
				)
			);
	}

	countMultimediaByNodo(
		idNodo: number,
		profundidad: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.countMultimediaByNodoUrl,
				{ idNodo, profundidad },
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`post countMultimediaByNodo`)
				)
			);
	}

	downloadMultimedia(idMultimedia: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.downloadMultimediaUrl, { idMultimedia }, options)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`post downloadMultimedia`)
				)
			);
	}

	renameMultimedia(
		idMultimedia: number,
		nuevoNombre: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.renameMultimediaUrl,
				{ idMultimedia, nuevoNombre },
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`POST renameMultimedia`)
				)
			);
	}

	////////////////////////////////////////////////

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
